import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import LoginBackground from '../../../assets/images/login-background.svg';
import IconOpenedEye from '../../../assets/icons/IconOpenedEye';
import IconClosedEye from '../../../assets/icons/IconClosedEye';
import OutsideLogo from '../../../components/Common/OutsideLogo';
import Alert from '../../../components/Alert/Alert';

class NewPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            forgetCode: '',
            newPassword: '',
            confirmNewPassword: '',
            versionRelease: '',
            disabled: false,
            showPassword1: '',
            showPassword2: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    componentDidMount() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const forgetCode = urlParams.get('forget_code');
        const email = urlParams.get('email');

        if (forgetCode !== null && email !== null) {
            this.setState({ email, forgetCode, disabled: true })
        }
    }

    removeAttribute = e => {
        e.target.removeAttribute('readonly')
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            email: this.state.email,
            forget_code: this.state.forgetCode,
            new_password: this.state.newPassword,
            verify_new_password: this.state.confirmNewPassword
        }

        API_AUTHENTICATION.postNewPassword(data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => this.props.history.push(ROUTER_CONSTANT.LOGIN), 1500)
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    render() {
        return (
            <div className="w-screen h-screen bg-white relative">
                <OutsideLogo />
                <img alt="Login Background" src={LoginBackground} className="w-full h-full object-contain" />
                <form onSubmit={this.handleSubmit} className="absolute top-32 right-56 w-96 text-gray-600">
                    <p className="text-3xl font-bold">Atur Ulang Kata Sandi</p>
                    <div className="quote font-medium mt-5 mb-20">
                        <p>Masukkan kode yang telah kami kirim ke email Anda.</p>
                    </div>
                    <input
                        type="text"
                        id="tslemail"
                        name="email"
                        placeholder="Email"
                        autoComplete="off"
                        onFocus={this.removeAttribute}
                        onChange={this.handleChange}
                        value={this.state.email}
                        disabled={this.state.disabled}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <input
                        type="text"
                        id="tslforgetcode"
                        name="forgetCode"
                        placeholder="Kode Verifikasi"
                        onChange={this.handleChange}
                        value={this.state.forgetCode}
                        disabled={this.state.disabled}
                        className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                    />
                    <div className="relative">
                        <input
                            type={this.state.showPassword1 ? "text" : "password"}
                            id="tslnewpassword"
                            name="newPassword"
                            placeholder="Kata Sandi Baru"
                            onChange={this.handleChange}
                            value={this.state.newPassword}
                            className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                        />
                        <div className="absolute right-5 top-1/2 transform -translate-y-1/2">
                            {
                                this.state.showPassword1
                                    ? <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: false })} className="cursor-pointer">
                                        <IconOpenedEye />
                                    </div>
                                    : <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: true })} className="cursor-pointer">
                                        <IconClosedEye />
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="relative">
                        <input
                            type={this.state.showPassword2 ? "text" : "password"}
                            id="tslconfirmnewpassword"
                            name="confirmNewPassword"
                            placeholder="Konfirmasi Kata Sandi Baru"
                            onChange={this.handleChange}
                            value={this.state.confirmNewPassword}
                            className="bg-input-outside w-full h-16 text-center outline-none rounded my-2 px-14"
                        />
                        <div className="absolute right-5 top-1/2 transform -translate-y-1/2">
                            {
                                this.state.showPassword2
                                    ? <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: false })} className="cursor-pointer">
                                        <IconOpenedEye />
                                    </div>
                                    : <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: true })} className="cursor-pointer">
                                        <IconClosedEye />
                                    </div>
                            }
                        </div>
                    </div>
                    <p className="text-sm">min. 8 karakter dan setidaknya <br /> mengandung huruf besar, angka dan simbol</p>
                    <button type="submit" id="btnsave" className="bg-darkblue w-full h-16 text-center text-white outline-none rounded mt-10">Simpan</button>
                </form>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Reset Password!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token
    };
};

export default withRouter(connect(mapStateToProps, null)(NewPassword));